import Vue from 'vue'
import Router from 'vue-router'
import news from './news'
import order from './order'
import bindaccount from './bind-account'
import managecenter from './manage-center'
import shoppingcart from './shopping-cart'
import home from './home'
import presell from './pre-sell'
import distributor from './distributor'
import invoice from './invoice'
import policycontent from './policy-content'
import categorylist from './categorylist'
import goodsdetails from './goods-details'
Vue.use(Router)

const routes = [
  // {
  //   path: '/home',
  //   name: 'main',
  //   component: () => import(/* webpackChunkName: "news" */ '@/pages/Main.vue'),
  //   children: [...news, ...order, ...bindaccount, ...managecenter, ...shoppingcart, ...home, ...presell, ...distributor, ...invoice, ...policycontent]
  // },
  ...news,
  ...order,
  ...bindaccount,
  ...managecenter,
  ...shoppingcart,
  ...home,
  ...presell,
  ...distributor,
  ...invoice,
  ...policycontent,
  ...categorylist,
  ...goodsdetails,
  // {
  //   path: '/home',
  //   name: 'main',
  //   component: () => import(/* webpackChunkName: "news" */ '@/pages/Main.vue'),
  //   children: [...news, ...order, ...bindaccount, ...managecenter, ...shoppingcart, ...home, ...presell, ...distributor, ...invoice, ...policycontent, ...categorylist]
  // },
  {
    path: '*',
    redirect: '/home'
  },
  {
    path: '/error',
    component: () =>
      import(/* webpackChunkName: "error" */ '@/pages/error/logic-error.vue')
  }
]
export default new Router({
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      if (to.meta.y) {
        document.querySelector('#container').scrollTo(0, to.meta.y)
      }
      return savedPosition
    } else {
      const container = document.querySelector('#container')
      let position = {
        x: 0,
        y: 0
      }
      if (container) {
        const y = from.meta.y = document.querySelector('#container').scrollTop
        position.y = y
      }
      return position
    }
  }
})
